import { Box, styled } from '@mui/material'
import { ToggleSwitch } from 'packages/eid-ui'
import { useTranslation } from 'react-i18next'
import { mobileScreenWidth, smallScreenWidth } from 'utils'
import { useState, useEffect } from 'react'

export const StyledResetButtonContainer = styled(Box)({
    width: '100%',
    margin: '-8px 0px 0px -8px',
    display: 'flex',
    alignItems: 'center',

    [`@media (max-width:${smallScreenWidth})`]: {
        margin: '-8px 0px 0px -8px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        '& >button': {
            marginLeft: 0,
            marginBottom: '10px',
        },
    },

    [`@media (min-width:${smallScreenWidth})`]: {
        '& >button': {
            marginRight: '50px',
        },
    },
})

export const StyledSectionTitle = styled(Box)({
    color: '#5d6870',
    fontSize: '18px',
    fontWeight: 'bold',
})

export const StyledDigestNotificationContainer = styled(Box)({
    borderRadius: '5px',
    boxShadow: ' 0 4px 6px -2px rgba(0, 0, 0, 0.1)',
    border: ' solid 1px #ebebed',
    backgroundColor: ' #ffffff',
    '& .Label': {
        width: '100%',
        [`@media (max-width:${mobileScreenWidth})`]: {
            paddingRight: '14px',
        },
    },
})

export const StyledPageContainer = styled(Box)({
    padding: '20px',
    [`@media (max-width:${smallScreenWidth})`]: {
        padding: '20px 4px',
    },
})

export const StyledContainer = styled(Box)({
    borderRadius: ' 5px',
    boxShadow: ' 0 4px 6px -2px rgba(0, 0, 0, 0.1)',
    border: ' solid 1px #ebebed',
    backgroundColor: ' #ffffff',
})

const StyledRow = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #d8d8dd',
    width: '100%',
    justifyContent: 'space-between',
    padding: '16px',
    '&:last-child': {
        borderBottom: 'none',
    },
    overflow: 'hidden',
})

const StyledFirstColumn = styled(Box)({
    display: 'flex',
    flexWrap: 'wrap',
    width: 'calc(100% - 120px)',
})

const StyledLabel = styled(Box)({
    fontSize: '16px',
    color: '#5d6870',
    paddingRight: '30px',
    [`@media (min-width:${smallScreenWidth})`]: {
        width: '35%',
    },
})

const StyledDescription = styled(Box)({
    color: '#848992',
    fontSize: '13px',
    display: 'flex',
    alignItems: 'cenetr',
    justifyContent: 'flex-start',
    [`@media (min-width:${smallScreenWidth})`]: {
        width: '65%',
    },
})

const StyledSwitchContainer = styled(Box)({
    width: '15%',
    minWidth: '115px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
})

export const Row = (props) => {
    const { t } = useTranslation()
    const { label, description, active, onChange, actionComponent } = props

    const [isActive, setIsActive] = useState(active)
    const switchLabelId =
        typeof label === 'string' && label.trim()
            ? `notification-label-${label.replace(/\s+/g, '-').toLowerCase()}`
            : 'notification-label-toggle'

    const handleChange = () => {
        setIsActive((pre) => !pre)
    }
    useEffect(() => {
        if (active !== isActive) {
            onChange(isActive)
        }
    }, [isActive])
    return (
        <StyledRow
            data-ai-explain={
                typeof label === 'string' && label.trim()
                    ? `Notification preference: ${label}`
                    : 'Notification preference'
            }
        >
            <StyledFirstColumn>
                <StyledLabel id={switchLabelId}>{label}</StyledLabel>

                <StyledDescription>{description}</StyledDescription>
            </StyledFirstColumn>

            <StyledSwitchContainer>
                {actionComponent ? (
                    actionComponent
                ) : (
                    <>
                        <ToggleSwitch
                            value={isActive}
                            onChange={handleChange}
                            aria-labelledby={switchLabelId}
                            // disabled={loading} Note: We might need this in future
                        />
                        <span>{isActive ? t('Yes') : t('No')}</span>
                    </>
                )}
            </StyledSwitchContainer>
        </StyledRow>
    )
}
